/**
 * 托盘管理
 */
 import axios from '../request';
 export default{
    

    /**
     * 托盘管理
     */
    // 查询托盘列表信息
    searchTrayList: params =>
        axios.post(`/materials/tray/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    // 添加或修改托盘信息
    insertTrayOrUpdate: params =>
        axios.post('/materials/tray/addOrUpdate', params),
    // 托盘信息详情
    detailsTrayDevice: params =>
        axios.post('/materials/tray/detail', params),
    // 删除托盘信息
    deleteTrayDevice: params =>
        axios.post('/materials/tray/delete', params),
    //托盘管理下拉
    getAllTrayDevice: params =>
        axios.get('/materials/', {params}),
    //导出数据
    exportTrayDatas:params=>
        axios({
            method: 'get',
            url: '/materials/tray/export',
            responseType: 'blob',
            params: params
        }),


 }